@if (filteredList && filteredList.length > 0) {
  <div class="flex flex-column gap-1">
    @for (poi of filteredList; track poi.key) {
      <div
        class="flex align-items-center justify-content-between py-1 px-2 border-round hover:surface-100 cursor-pointer"
        [class.surface-200]="poi.key === activeKey"
        (click)="poiClick(poi)">
        <span
          class="text-sm overflow-hidden text-overflow-ellipsis white-space-nowrap mr-2"
          [pTooltip]="poi.name"
          tooltipPosition="top">
          {{ poi.name }}
        </span>
        <div class="flex gap-1">
          <p-button
            [rounded]="true"
            [text]="true"
            icon="fas fa-location-dot"
            styleClass="p-button-xs"
            (click)="poiClick(poi)"
            pTooltip="Auf Karte zeigen"
            tooltipPosition="left" />
          <p-button
            [rounded]="true"
            [text]="!isIsochroneActive(poi)"
            [severity]="isIsochroneActive(poi) ? 'primary' : 'secondary'"
            icon="fas fa-route"
            styleClass="p-button-xs"
            (click)="toggleIsochrone($event, poi)"
            pTooltip="Erreichbarkeit"
            tooltipPosition="left" />
        </div>
      </div>
    }
  </div>
}
